var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"item",class:{enable: !_vm.codeDisable, disable: _vm.codeDisable},attrs:{"disabled":_vm.codeDisable},on:{"click":_vm.onclick}},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.codeText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f2af9b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CountdownButton.vue
// module id = null
// module chunks = 